interface NodeContent {
  feature_group: string;
  content: string;
}

export interface CapsuleData {
  nodes: NodeContent[];
}

interface InjectedContent {
  head: string;
  body: string;
}

function injectCapsuleContent(capsuleData: CapsuleData): InjectedContent {
  // Initialize an object to hold the content for head and body
  const content: InjectedContent = {
    head: "",
    body: "",
  };

  // Check if nodes exist in the capsule data
  if (capsuleData && capsuleData.nodes) {
    // Iterate over each node in the capsule data
    capsuleData.nodes.forEach((node) => {
      // Determine where to inject the content based on the feature_group
      switch (node.feature_group) {
        case "_head_open":
          // Accumulate head content
          content.head += node.content;
          break;
        case "body_1":
          // Accumulate body content
          content.body += node.content;
          break;
        // Add cases for other feature_groups if necessary
      }
    });
  }

  return content;
}

export default injectCapsuleContent